import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../lib/baseQueries";

export interface INotification {
  id: string;
  userId: string;
  title: string;
  message: string;
  type: "SUCCESS" | "ERROR" | "INFO" | string;
  channels: string;
  read: boolean;
  link?: string;
  deliveryStatus: string;
  createdAt: string;
  updatedAt: string;
}

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Notification"],
  endpoints: (builder) => ({
    getNotifications: builder.query<INotification[], void>({
      query: () => ({
        url: "/v1/notifications",
        method: "GET",
      }),
      providesTags: ["Notification"],
    }),
    markAsRead: builder.mutation<{ status: string }, string>({
      query: (id) => ({
        url: `/v1/notifications/${id}/read`,
        method: "PATCH",
      }),
      invalidatesTags: ["Notification"],
    }),
    markAllAsRead: builder.mutation<{ status: string }, void>({
      query: () => ({
        url: "/v1/notifications/read-all",
        method: "POST",
      }),
      invalidatesTags: ["Notification"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
} = notificationApi;
